window._cartRefresh = async function (existingCartData = null) {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const sections = cart.getSectionsToRender().map(section => section.id).join(',');
    try {
        const [sectionRes, cartRes] = await Promise.all([
            fetch(`/?sections=${sections}`).then(res => res.json()),
            existingCartData ? Promise.resolve(existingCartData) : fetch('/cart.js').then(res => res.json())
        ]);
        const cartDrawer = document.querySelector('cart-drawer');
        const cartIconBubbleHtml = new DOMParser().parseFromString(sectionRes['cart-icon-bubble'], 'text/html').getElementById('shopify-section-cart-icon-bubble').innerHTML;
        document.getElementById('cart-icon-bubble').innerHTML = cartIconBubbleHtml;
        if (cartDrawer) {
            const cartDrawerHtml = new DOMParser().parseFromString(sectionRes['cart-drawer'], 'text/html').querySelector('cart-drawer').innerHTML;
            cartDrawer.classList.toggle('is-empty', cartRes.item_count === 0);
            cartDrawer.innerHTML = cartDrawerHtml;
            cartDrawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', cartDrawer.close.bind(cartDrawer));
        }
    } catch (err) {
        console.error('Error in _cartRefresh:', err);
    }
};